








import Vue, { PropType } from "vue";
import { UserQuery_user } from "@/graphql/generatedTypes/UserQuery";

export default Vue.extend({
  name: "LeaderSelect",
  inheritAttrs: false,
  props: {
    value: String as PropType<string>,
    items: Array as PropType<UserQuery_user[]>,
    defaultValue: String as PropType<string>
  },
  data() {
    return {
      id: this.defaultValue
    };
  },
  mounted() {
    this.id = this.id || this.defaultValue;
    this.$emit("input", this.defaultValue);
  },
  watch: {
    defaultValue() {
      this.id = this.id || this.defaultValue;
      this.$emit("input", this.id || this.defaultValue);
    },
    id(value: string) {
      this.$emit("input", value);
    }
  },
  methods: {
    endIntersect() {
      this.$emit("endIntersectTrainers");
    },
    mapToAutoComplete(users?: { id: string; email: string }[]): { text: string; value: string }[] {
      if (!users) {
        return [];
      }
      return users.map((user: { id: string; email: string }) => ({
        value: user.id,
        text: user.email
      }));
    }
  }
});
